import type { GcsData } from '../../types/gcs/gcsData';
import type { CenterUnitSystem } from '../../types/gcs/center';

const DEFAULT_UNIT_SYSTEM: CenterUnitSystem = 'metric';

/**
 * Selector to resolve a center's unit system for a specific GCS.
 * Falls back to 'metric' when unit system is unknown.
 */
export function selectUnitSystem(data: Map<string, GcsData>, gcsId: string): CenterUnitSystem {
  return data.get(gcsId)?.center.data?.unitSystem ?? DEFAULT_UNIT_SYSTEM;
}

/**
 * Selector to resolve a center's unit system for a specific GCS.
 * Returns undefined when unit system is unknown.
 */
export function selectUnitSystemOrUndefined(data: Map<string, GcsData>, gcsId: string): CenterUnitSystem | undefined {
  const unitSystem = data.get(gcsId)?.center.data?.unitSystem;
  return unitSystem ?? undefined;
}
